/*
 * Life event cards (snippets/la-life-event-card.liquid): line up each row's
 * sub-topics boxes in browsers without CSS subgrid. Where subgrid works,
 * assets/la-life-event-card.css already does this and the script stops here.
 *
 * Otherwise, in each visual row of cards, the title + subtitle blocks and the
 * sub-topics boxes get the height of the tallest one in that row. It re-runs
 * when a grid's width changes, after fonts load, and when a section reloads in
 * the theme editor.
 */
(function () {
  if (
    window.CSS &&
    CSS.supports &&
    CSS.supports("grid-template-rows", "subgrid")
  )
    return;

  var PARTS = [".la-le-card__text", ".la-le-card__tags"];

  function equalize(grid) {
    var cards = Array.prototype.filter.call(grid.children, function (el) {
      return el.classList.contains("la-le-card");
    });

    PARTS.forEach(function (selector) {
      var rows = {};
      cards.forEach(function (card) {
        var part = card.querySelector(selector);
        if (!part) return;
        part.style.minHeight = "";
        (rows[card.offsetTop] = rows[card.offsetTop] || []).push(part);
      });

      Object.keys(rows).forEach(function (top) {
        var parts = rows[top];
        if (parts.length < 2) return;
        var tallest = Math.max.apply(
          null,
          parts.map(function (part) {
            return part.offsetHeight;
          }),
        );
        parts.forEach(function (part) {
          part.style.minHeight = tallest + "px";
        });
      });
    });
  }

  function grids() {
    var found = [];
    document.querySelectorAll(".la-le-card").forEach(function (card) {
      if (found.indexOf(card.parentElement) === -1)
        found.push(card.parentElement);
    });
    return found;
  }

  function run() {
    grids().forEach(equalize);
  }

  // Only a width change can re-wrap text; our own min-height changes only alter height.
  var widths = new WeakMap();
  var observer =
    "ResizeObserver" in window
      ? new ResizeObserver(function (entries) {
          entries.forEach(function (entry) {
            var width = Math.round(entry.contentRect.width);
            if (widths.get(entry.target) === width) return;
            widths.set(entry.target, width);
            equalize(entry.target);
          });
        })
      : null;

  function watch() {
    run();
    if (observer)
      grids().forEach(function (grid) {
        observer.observe(grid);
      });
  }

  watch();
  if (!observer) window.addEventListener("resize", run);
  window.addEventListener("load", run);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(run);
  document.addEventListener("shopify:section:load", watch);
})();
